module.exports = __webpack_public_path__ + "img/GitLab.d13bef02.png";